import { Component, Input, OnInit, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  imports: [
    MatIcon,
    MatButton
  ],
  providers: [
    // Router
  ],
  selector: 'equine-ui-nx-payment-error',
  templateUrl: './payment-error.component.html',
  styleUrls: ['./payment-error.component.scss']
})
export class PaymentErrorComponent {
  private router = inject(Router);

  backToShoppingCart() {
    this.router.navigate(['payments', 'payment-summary']);
  }
}
